import React from "react";
import AssignDeviceLayer from "../components/school/AssignDeviceLayer";
import MasterLayout from "../masterLayout/MasterLayout";

export const AssignDevicePage = () => {
  return (
    <MasterLayout>
      <AssignDeviceLayer />
    </MasterLayout>
  );
};

export default AssignDevicePage;
